import React, { useRef, useState, useEffect } from 'react';
import SunEditor from 'suneditor-react';
import { pt_br } from 'suneditor/src/lang';
import styled from 'styled-components';
import 'suneditor/dist/css/suneditor.min.css';
import Modal from './ConfirmationModal';

const ContractModelForm = ({ formik, options, className }) => {
  const editorRef = useRef(null);
  const mainRef = useRef(null);
  const [hidden, setHidden] = useState(false);
  const [showOptionsModal, setShowOptionsModal] = useState(false);

  const addValue = (value) => {
    const editor = editorRef.current;
    editor.insertHTML(`{{ ${value} }}`);
    formik.setFieldValue('contract_body', editor.getContents());
    setShowOptionsModal(false);
  };

  const handleChange = (content) => {
    formik.setFieldValue('contract_body', content);
  };

  const handleScroll = () => {
    if (window.scrollY > 300) {
      setHidden(true);
    } else {
      setHidden(false);
    }
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
  }, [window.scrollY]);

  return (
    <div className={className} ref={mainRef}>
      <Modal
        visible={showOptionsModal}
        title="Adicionar valores dinâmicos"
        onCancel={() => setShowOptionsModal(false)}
        scrollable
      >
        <div className={'buttons_div'}>
        {options &&
          options.map((opt) => {
            return (
              <div style={{marginTop: "10px"}} className='d-flex '>
                <button
                  type="button"
                  onClick={() => addValue(opt.value)}
                  className={'buttons'}
                  >
                  {opt.name}
                </button>
              </div>
            );
          })}
          </div>
      </Modal>
      <div className={'buttons_div'}>

        <button
          type="button"
          onClick={() => setShowOptionsModal(true)}
          className={'buttons'}
          >
          Adicionar valores dinâmicos.
        </button>
          </div>
      <SunEditor
        id="editor"
        getSunEditorInstance={(editor) => {
          editorRef.current = editor;
        }}
        hideToolbar={hidden}
        setOptions={{
          height: 'auto',
          lang: pt_br,
          font: [
            'Arial',
            'Comic Sans MS',
            'Courier New',
            'Impact',
            'Georgia',
            'Tahoma',
            'Trebuchet MS',
            'Verdana',
          ],
          defaultStyle:
            'font-family: Arial; font-size: 12px; min-height: 500px;',
          buttonList: [
            ['font', 'fontSize', 'formatBlock'],
            [
              'bold',
              'underline',
              'italic',
              'strike',
              'subscript',
              'superscript',
            ],
            ['align', 'horizontalRule', 'list', 'lineHeight'],
            ['fontColor', 'hiliteColor', 'textStyle'],
            ['table', 'link'],
            ['paragraphStyle', 'blockquote'],
            ['outdent', 'indent'],
            ['undo', 'redo'],
            ['removeFormat'],
            ['fullScreen', 'codeView'],
          ],
        }}
        defaultValue={formik.values.content}
        onChange={handleChange}
      />
    </div>
  );
};

export default styled(ContractModelForm)`
 .buttons_div {
    width: 100%;
    height: auto;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    // overflow-y: scroll;
    // overflow-x: hidden;
    gap: 10px;
    margin-bottom: 10px;
    white-space: nowrap;

    ::-webkit-scrollbar {
      width: 6px;
    }
    ::-webkit-scrollbar-track {
      background: transparent;
    }
    ::-webkit-scrollbar-thumb {
      background: #489d96;
      border-radius: 10px;
    }

    ::-webkit-scrollbar-thumb:hover {
      background: #35746e;
      cursor: pointer;
    }
}


  .buttons {
    width: auto;
    height: 30px;
    background-color: #489d96;
    color: #fff;
    border-radius: 5px;
    font-size: 13px;
    border: none;
    cursor: pointer;
    letter-spacing: 0.05em;
    text-transform: capitalize;
  }
`;
